module.exports = __webpack_public_path__ + "static/media/Chiu_NTÜ_NasalMerging_1128.67ca4467.pdf";